'use strict';

angular.module('atex.dam').directive('damThumbSlider', function () {
  var linkFn = function (scope, element, attrs) {
    element.slider({
      max: 180,
      min: 120,
      value: scope.currentLineHeight,
      slide: function (event, ui) {
        scope.$parent.$parent.setCurrentLineHeight(ui.value);
        //scope.setCurrentLineHeight(ui.value);
        $('.entry-container').css({
          height: ui.value
        });
        $('.img-thumb').css({
          height: ui.value
        });
        $('.img-thumb').css({
          width: 'auto'
        });
        scope.$digest();
      }
    });
  };
  return {
    scope: false,
    restrict: 'A',
    link: linkFn
  };
});

angular.module('atex.dam').directive('damToggleFullscreen', function (DamService) {
  var linkFn = function (scope, element, attrs) {
    // The element here is the id 'dam-list'
    scope.$watch(attrs.damToggleFullscreen, function (val) {

      if (DamService.isMobileDevice()) {
        return;
      }

      if (val) {
        scope.damSearchOldWidth = $('#dam-menu').width();
        $('#dam-menu').addClass('hidden-lg');
        $('#dam-preview').addClass('hidden-lg');
        element.removeClass("col-lg-7");
        element.addClass("col-lg-12");
        element.css("height", "100%");
        element.css("max-height", "100%");
        $('#dam-top-row').css("height", "100%");
      } else {
        if (scope.damSearchOldWidth >= 0) {
          $('#dam-menu').removeClass('hidden-lg');
          $('#dam-preview').removeClass('hidden-lg');
          element.removeClass("col-lg-12");
          element.addClass("col-lg-7");
          element.css("height", "98%");
          element.css("max-height", "98%");
          $('#dam-top-row').css("height", "100%");
          scope.damSearchOldWidth = -1;
        }
      }
    });
  };
  return {
    scope: false,
    restrict: 'A',
    link: linkFn
  };
});

angular.module('atex.dam').directive('damKeysScrollList', function ($timeout) {
  var linkFn = function (scope, element, attrs) {
    scope.$on('keydown', function (msg, code) {
      // Not handle key up and key down in thumbnail view
      if (scope.thumb === true) {
        return;
      }
      if (element.is(':focus') !== true) {
        return;
      }
      var findById = function (entry) {
        return (entry && entry.id === this.id);
      };
      var findActiveTr = function () {
        if (scope.list === true) {
          return element.find('#dam-list-listview tr.selected');
        } else if (scope.thumb_list === true) {
          return element.find('#dam-list-thumblistview tr.success');
        } else if (scope.physPage === true) {
          return element.find('.selected');
        }
        return undefined;
      };

      var scrollList = function () {
        var content = element.find('#table-wrapper');
        if (content && content.length > 0) {
          var _offset = 100;
          var _button = $('#table-list-anchor');
          if (_button && _button.length > 0) {
            _offset = _button[0].offsetTop - 82;
          }
          var bounding = activeTr[activeTr.length - 1].getBoundingClientRect().top;
          if(_button[0].offsetTop - bounding <= -80) {
            content.scrollTop(activeTr[activeTr.length - 1].offsetTop - _offset);
          }
        }
      };

      var scrollToLast = function () {
        if (typeof activeTr !== 'undefined') {
          if (activeTr[activeTr.length - 1]) {
            if (scope.physPage) {
              element.scrollLeft(activeTr[activeTr.length - 1].offsetLeft - 100);
            } else {
              element.scrollTop(activeTr[activeTr.length - 1].offsetTop - 100);
            }
          }
        }
      };

      var startIndex, endIndex, activeTr;
      if (code === 40 || code === 39) {// arrow key down or arrow right
        if (event.shiftKey) {
          startIndex = scope.entries.findIndex(findById, scope.selected[0]);
          endIndex = scope.entries.findIndex(findById,scope.selected[scope.selected.length - 1]) + 1;

          select(scope, startIndex, endIndex);

          activeTr = findActiveTr();
          if (scope.list === true) {
            scrollList();
          } else {
            scrollToLast();
          }
          return;
        }

        if (scope.selected.length === 1) {
          startIndex = scope.entries.findIndex(findById, scope.selected[0]);
          if((scope.numFound-1) === startIndex) {
            return;
          } else  if (startIndex < (scope.entries.length - 1)) {
            scope.selectSingle(scope.entries[startIndex + 1]);
            activeTr = findActiveTr();
            if (scope.list === true) {
              scrollList();
            } else {
              scrollToLast();
            }
          } else {
            if (scope.querying !== true) {
              scope.loadMore();
            }
          }
          scope.$apply();
        }
      } else if (code === 38 || code === 37) {// arrow key up or arrow left
        if (event.shiftKey) {
          startIndex = scope.entries.findIndex(findById, scope.selected[0]);
          endIndex = scope.entries.findIndex(findById,scope.selected[scope.selected.length - 1]) - 1;

          select(scope, startIndex, endIndex);
          activeTr = findActiveTr();
          if (scope.list === true) {
            scrollList();
          } else {
            scrollToLast();
          }
          return;
        }
        if (scope.selected.length === 1) {
          startIndex = scope.entries.findIndex(findById, scope.selected[0]);
          if (startIndex > 0) {
            scope.selectSingle(scope.entries[startIndex - 1]);
            scope.$apply();
            activeTr = findActiveTr();

            if (scope.list === true) {
              var wrapper = element.find('#table-wrapper');
              if(wrapper && wrapper.length > 0) {
                var off = 100;
                var more = $('#table-list-anchor-top');
                if (more && more.length > 0) {
                  off = more[0].offsetTop + 32;
                }
                var bound = activeTr[activeTr.length - 1].getBoundingClientRect().top;
                if(more[0].offsetTop - bound >= -140) {
                  wrapper.scrollTop(activeTr[activeTr.length - 1].offsetTop - off);
                }
              }
            } else {
              scrollToLast();
          }
        }
      }
      }
    });
  };

  var select = function (scope, startIndex, endIndex) {
    scope.clearSelection();
    scope.selected.push(scope.entries[startIndex]);
    if (endIndex >= scope.entries.length) {
      endIndex = scope.entries.length - 1;
    }
    if (startIndex >= 0 && endIndex >= 0) {

      while (startIndex < endIndex) {
        startIndex++;
        scope.selected.push(scope.entries[startIndex]);
      }
      while (startIndex > endIndex && startIndex > 0) {
        startIndex--;
        scope.selected.push(scope.entries[startIndex]);
      }
    }
    $timeout(function () {
      scope.notifyPreview(scope.entries[endIndex], true);
    });
  };
  return {
    scope: false,
    restrict: 'A',
    link: linkFn
  };
});
/*
 angular.module('atex.dam').directive('damScrolling', ['$rootScope', function($rootScope) {
 var linkFn = function(scope, element, attrs) {
 angular.element(element).bind("scroll", function() {
 if (element[0].scrollTop > (element[0].scrollHeight-(element[0].clientHeight*2))) {
 $rootScope.$broadcast('dam:listScrollingDown');
 }
 });
 };
 return {
 scope : false,
 restrict : 'A',
 link : linkFn
 };
 }]);
 */
